import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { CidadeService } from '@app/services/cidade.service';
import { Cidade } from '@app/models/cidade';

import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cidade-lista',
  templateUrl: './cidade-lista.component.html'
})

export class CidadeListaComponent implements OnInit {

  lstCidade: Cidade[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private cidadeService: CidadeService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.cidadeService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstCidade = data.Dados,
        this.paginacao.totalDeItens = data.Total
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(cidade: Cidade) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir a cidade: " + cidade.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.cidadeService.deletar(cidade.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
